import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestViewerAction } from '@shared/common/_requests/request_viewer_action';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../generation/STATE__generation';

export const remote_workspace_child_entity_viewer_action = createAsyncThunkSafe<void, RequestViewerAction>(
  ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_VIEWER_ACTION,
  async (action: RequestViewerAction): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_VIEWER_ACTION, action);
  },
);

export function init_remote_workspace_child_entity_viewer_action(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(remote_workspace_child_entity_viewer_action.pending, (state, action) => {})
    .addCase(remote_workspace_child_entity_viewer_action.rejected, (state, action) => {})
    .addCase(remote_workspace_child_entity_viewer_action.fulfilled, (state, action: PayloadAction) => {});
}
